/**
 *  Vuex module wordpress/account
 */
import types from './types'

/**
 * Mutations for wordpress/account module
 */
const mutations = {
  [types.URL]: (state, payload) => { state.url = payload },
  [types.USERNAME]: (state, payload) => { state.username = payload },
  [types.PASSWORD]: (state, payload) => { state.password = payload },
  [types.LOGIN]: (state, payload) => {
    state.token = payload.token
    state.email = payload.user_email
  },
  [types.GET_ID]: (state, payload) => {
    state.id = payload.id
    state.avatar_url = payload.avatar_urls['96']
  },
  [types.LOGOUT]: (state, payload) => {
    // localStorage.removeItem('token')
    // localStorage.removeItem('id')
    // localStorage.removeItem('email')
    state.token = ''
    state.id = ''
    state.email = ''
    // state.posts = []
    // state.post = null
    // state.pages = []
    // state.page = null
    // state.media = []
    // state.chat.message = ''
    // state.chat.messages = []
    // state.chat.lastMessage = null
    // state.settings = cloneDeep(getSettingsFromTemplate(settingsTemplate))
    // state.themes.colors = cloneDeep(defaultColors)
    // state.themes.css = ''
    // state.themes.header = {html: '', css: '', component: null}
    // state.themes.navigation = {html: '', css: '', component: null}
    // state.themes.sidebar = {html: '', css: '', component: null}
    // state.themes.footer = {html: '', css: '', component: null}
  }
  // [types.LOGOUT]: (state, payload) => {
  //   // state = cloneDeep(initialState)
  //   localStorage.removeItem('jwt')
  //   localStorage.removeItem('id')
  //   localStorage.removeItem('email')
  //   state.user.jwt = ''
  //   state.user.id = ''
  //   state.user.email = ''
  //   state.posts = []
  //   state.post = null
  //   state.pages = []
  //   state.page = null
  //   state.media = []
  //   state.chat.message = ''
  //   state.chat.messages = []
  //   state.chat.lastMessage = null
  //   // state.settings = cloneDeep(getSettingsFromTemplate(settingsTemplate))
  //   // state.themes.colors = cloneDeep(defaultColors)
  //   // state.themes.css = ''
  //   // state.themes.header = {html: '', css: '', component: null}
  //   // state.themes.navigation = {html: '', css: '', component: null}
  //   // state.themes.sidebar = {html: '', css: '', component: null}
  //   // state.themes.footer = {html: '', css: '', component: null}
  // }
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/modules/wordpress/account/mutations.js